<div class="menu-content bg-dark text-white scrollable">
  <div class="my-4 row-container">
    <button
      mat-menu-item
      [matMenuTriggerFor]="language"
      aria-labelledby="current-language"
    >
      <span id="current-language" class="text-white">
        🌐 {{ currentLanguage | uppercase }}
      </span>
    </button>
    <button
      mat-menu-item
      [matMenuTriggerFor]="currency"
      aria-labelledby="current-currency"
    >
      <span id="current-currency" class="text-white">
        💲{{ currentCurrency }}
      </span>
    </button>

    <mat-menu #language="matMenu">
      <button
        mat-menu-item
        *ngFor="let language of languages"
        (click)="languageSelected.emit(language.code)"
        [value]="language"
        aria-labelledby="language-name"
      >
        <span id="language-name"> {{ language.name }}</span>
      </button>
    </mat-menu>
    <mat-menu #currency="matMenu" data-cy="menuCurrencyOptions">
      <button
        mat-menu-item
        *ngFor="let currency of currencies"
        (click)="currencySelected.emit(currency)"
        [value]="currency"
        [attr.data-cy]="'currencyOption' + currency"
        aria-labelledby="currency"
      >
        <span id="currency">{{ currency }}</span>
      </button>
    </mat-menu>
  </div>
  <div
    *ngIf="user?.email; else showLoginButton"
    class="mx-4 mt-4 row-container left align-center"
  >
    <lib-shared-ui-profile-avatar
      class="py-3 profile-avatar"
      [userName]="user?.displayName"
      [userPhoto]="user?.photoURL"
    >
    </lib-shared-ui-profile-avatar>
    <div class="ml-2 column-container left">
      <span class="mat-body-1 mt-3 text-white">{{
        user?.displayName ?? ''
      }}</span>
      <span class="mat-caption text-white">{{ user?.email ?? '' }}</span>
    </div>
  </div>
  <ng-template #showLoginButton>
    <a
      mat-menu-item
      (click)="closeMenu.emit()"
      routerLink="/login"
      aria-label="iniciar sesión"
      vakiCtrlRouterLink
    >
      <mat-icon color="primary">person</mat-icon>
      <span class="mat-body-2 text-primary" i18n>INICIAR SESIÓN</span>
    </a>
  </ng-template>
  <a
    mat-menu-item
    (click)="closeMenu.emit()"
    [routerLink]="'crear'"
    aria-label="crea una vaki"
    vakiCtrlRouterLink
  >
    <mat-icon color="primary">add</mat-icon>
    <span class="mat-body-2 text-primary" i18n>CREA TU VAKI</span>
  </a>
  <a
    mat-menu-item
    (click)="closeMenu.emit()"
    [routerLink]="'explorar'"
    aria-label="explorar"
    vakiCtrlRouterLink
  >
    <mat-icon color="primary">explore</mat-icon>
    <span class="mat-body-1 text-white">Explora las Vakis</span>
  </a>
  <a
    *ngIf="user?.email"
    mat-menu-item
    (click)="closeMenu.emit()"
    routerLink="dashboard"
    aria-label="ver dashboard"
    vakiCtrlRouterLink
  >
    <mat-icon color="primary">analytics</mat-icon>
    <span class="mat-body-1 text-white">Centro de control</span>
  </a>
  <a
    *ngIf="user?.email"
    mat-menu-item
    (click)="closeMenu.emit()"
    routerLink="/dashboard/profile"
    aria-label="ver cuenta"
    vakiCtrlRouterLink
  >
    <mat-icon color="primary">person</mat-icon>
    <span class="mat-body-1 text-white">Tu perfil</span>
  </a>
  <a
    mat-menu-item
    (click)="closeMenu.emit()"
    href="https://help.vaki.co/?utm_source=platform&utm_medium=side-menu&utm_campaign=v4"
    target="_blank"
    aria-label="ir al centro de ayuda"
    vakiCtrlRouterLink
  >
    <mat-icon color="primary">help</mat-icon>
    <span class="mat-body-1 text-white">Ayuda</span>
  </a>
  <a
    mat-menu-item
    (click)="closeMenu.emit()"
    href="https://app.loopedin.io/vaki#/ideas"
    target="_blank"
    aria-label="proponer una idea"
    vakiCtrlRouterLink
  >
    <mat-icon color="primary">lightbulb_outline</mat-icon>
    <span class="mat-body-1 text-white">Feedback</span>
  </a>
  <a
    mat-menu-item
    (click)="closeMenu.emit()"
    routerLink="blog"
    aria-label="blog"
    vakiCtrlRouterLink
  >
    <mat-icon color="primary">rss_feed</mat-icon>
    <span class="mat-body-1 text-white">Blog</span>
  </a>
  <a
    *ngIf="user?.uid"
    mat-menu-item
    class="w-100"
    (click)="logout.emit()"
    aria-label="cerrar sesión"
  >
    <mat-icon color="warn">logout</mat-icon>
    <span class="mat-body-1 text-white">Cerrar sesión</span>
  </a>
  <div class="menu-footer bg-dark mt-10">
    <div class="column-container">
      <a routerLink="/" *ngIf="logo" vakiCtrlRouterLink>
        <img
          [src]="logo.src"
          [alt]="logo.alt"
          loading="lazy"
          class="logo-img"
        />
      </a>
      <div class="column-container">
        <div class="my-2 row-container">
          <a
            class="social-icon social-icon--twitter transparent"
            vakiNewWindow
            href="https://twitter.com/VakiGlobal"
            vakiCtrlRouterLink
            >twitter</a
          >
          <a
            class="social-icon social-icon--facebook transparent"
            vakiNewWindow
            href="https://facebook.com/VakiGlobal"
            vakiCtrlRouterLink
            >facebook</a
          >
          <a
            class="social-icon social-icon--instagram transparent"
            vakiNewWindow
            href="https://instagram.com/VakiGlobal"
            vakiCtrlRouterLink
            >instagram</a
          >
          <a
            class="social-icon social-icon--youtube transparent"
            vakiNewWindow
            href="https://youtube.com/VakiGlobal"
            vakiCtrlRouterLink
            >youtube</a
          >
          <a
            class="social-icon social-icon--linkedin transparent"
            vakiNewWindow
            href="https://linkedin.com/company/VakiGlobal"
            vakiCtrlRouterLink
            >linkedin</a
          >
        </div>
        <span
          i18n="footer | Copyright Vaki @@copyrightVaki"
          class="mat-caption text-white"
        >
          © {{ currentYear }} Vaki Global, Ltd
        </span>
      </div>
    </div>
    <span class="mat-body-2 text-white pt-8">Con el apoyo de</span>
    <div class="column-container xs">
      <div>
        <a
          href="https://www.colombiafintech.co/lineaDeTiempo/empresa/vaki/articulos"
          target="_blank"
          vakiCtrlRouterLink
        >
          <img
            src="assets/images/logos/logo-colombia-fintech.svg"
            class="logo-partner"
            alt="Logo Colombia Fintech"
            loading="lazy"
          />
        </a>
      </div>
      <div>
        <a
          href="http://www.afico.org/sello.html"
          target="_blank"
          vakiCtrlRouterLink
        >
          <img
            src="assets/images/logos/partners/afico-light.png"
            class="logo-partner"
            alt="Logo AFICO"
            loading="lazy"
          />
        </a>
      </div>
    </div>
  </div>
</div>
